// extracted by mini-css-extract-plugin
export default {"wrap":"CustomerUsers_wrap__TAMZQ"};